import { Team } from "models/teams/Team";
import InviteTeammember from "components/teams/InviteTeammember";
import { TeamInvite } from "models/teams/TeamInvite";
import React, { useEffect, useState } from "react";
import { ApiService } from "services/ApiService";
import { TeamInviteStatus } from "models/teams/TeamInviteStatus";


const TeamInvites : React.FC<{ teamId: string }> = ({ teamId }) => {

    const [invites, setInvites] = useState<TeamInvite[]>([]);
    const [inviteChanged, setInviteChanged] = useState<number>(0);

    useEffect(() => {

        const fetchInvites = async () => {
            const userId = localStorage.getItem("userId");
            if (!userId) {
                console.error("User ID not found in localStorage.");
                return;
            }
            const invites = await ApiService.getTeamInvites(teamId, userId);

            if (!invites || !invites || !Array.isArray(invites)) {
                console.error("Failed to fetch invites or no invites found.");
                return;
            }
            console.log("Fetched invites:", invites);
            setInvites(invites);
        };

        fetchInvites();
    }, [teamId, inviteChanged]);

    const handleInviteChange = async (email: string) => {
        try{
            var response = await ApiService.createTeamInvite(teamId, email)

            if (!response || !response.data) {
                console.error("Failed to create invite.");
                return;
            }
        }
        catch (error){
            console.error("Error creating invite:", error);
            alert("Failed to create invite. Please try again.");
            return;
        }

        setInviteChanged(prev => prev + 1);

        alert("An invite was sent to " + email + ". Please ask them to check their email and accept the invite to join your team.");
    };

    return (
        <div className="p-4">
            <h2 className="text-xl font-bold mb-4">Team Invites</h2>
            {invites.length === 0 ? (
            <p className="text-gray-600">No invites found.</p>
            ) : (
            <ul className="mb-4">
                {invites.map((invite) => (
                <li key={invite.teamInviteId} className="border-b py-2">
                    <span className="font-medium">{invite.email}  Status: {invite.statusString}</span>
                    {invite.status && (
                    <span className="ml-2 text-sm text-gray-500">({invite.teamInviteId})</span>
                    )}
                </li>
                ))}
            </ul>
            )}
            <InviteTeammember onInvite={handleInviteChange} />
        </div>
    );
}

export default TeamInvites;